import axios from "axios";
import store from "@/store";

const SESSION_GONE = "uživatel není přihlášen";
const SKIP_METHODS = new Set([
  "UserLogin",
  "UserLogout",
  "UserRegistration",
  "UserRegConfirm",
  "GetRegistration",
  "UserObsolete"
]);

let handling = false;

const flattenMessages = (err) => {
  if (err == null || err === "") return [];
  if (Array.isArray(err)) return err.flatMap(flattenMessages);
  if (typeof err === "object") return Object.values(err).flatMap(flattenMessages);
  return [String(err)];
};

const requestMethod = (config) => {
  try {
    const body = typeof config?.data === "string" ? JSON.parse(config.data) : config?.data;
    return body?.Method || "";
  } catch (e) {
    return "";
  }
};

const isSessionGone = (payload) => {
  const messages = flattenMessages(payload?.ErrorMessage);
  return messages.some((msg) => msg.toLowerCase().includes(SESSION_GONE));
};

const maybeExpireSession = (response) => {
  if (handling) return;
  if (!store.getters.isLoggedIn) return;
  if (SKIP_METHODS.has(requestMethod(response?.config))) return;
  if (!isSessionGone(response?.data)) return;

  handling = true;
  store.dispatch("sessionExpired").finally(() => {
    handling = false;
  });
};

export const installSessionGuard = () => {
  axios.interceptors.response.use(
    (response) => {
      maybeExpireSession(response);
      return response;
    },
    (error) => {
      maybeExpireSession(error?.response);
      return Promise.reject(error);
    }
  );
};
